// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2DQBU","col":"Table_col__3X9p5","fulfillmentStatus":"Table_fulfillmentStatus__nop-v","emailCol":"Table_emailCol__gviBI"};